import React from 'react';

const ArrowLeft = ({
  color = '#E06358',
  ...props
}: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.068 6.13965H0.931641"
        stroke={color}
        strokeWidth="0.85"
        strokeMiterlimit="10"
      />
      <path
        d="M5.7085 10.9175L0.931641 6.14063L5.7085 1.36377"
        stroke={color}
        strokeWidth="0.85"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default ArrowLeft;
